/* eslint-disable jsx-a11y/control-has-associated-label,import/no-unresolved */
import React, { useEffect, useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import moment from 'moment/moment';
import { isBrowser } from 'react-device-detect';
import {
  PersonalInfoUserSettingIcon,
  PersonalInfoAtSymbolIcon,
  PersonalInfoCalendarIcon,
  PersonalInfoPhoneIcon,
  PersonalInfoShopIcon,
} from 'assets/components';
import { useUserPersonalInfo } from '../../../utilities/sharedHooks/user';
import { useSetting } from '../../../utilities/sharedHooks/settings';
import { dynamicAssets } from '../../../utilities/helpers';

const PersonalInfo = () => {
  const { t: translate } = useTranslation();

  const [ledgerSupportEmailAddress] = useSetting('server_configurations', 'support_email_address');

  const {
    dateOfBirth,
    firstName,
    lastName,
    selectedCountry,
    email,
    houseNumber,
    postCode,
    city,
    street,
    isUS,
    usState,
    normalizedPhoneNumber,
    countryCode,
  } = useUserPersonalInfo();

  const formatedDateOfBirth = moment.utc(dateOfBirth).format(isUS ? 'MM/DD/YYYY' : 'DD/MM/YYYY');
  const emailElmRef = useRef(null);
  const addressElmRef = useRef(null);

  const fullAddress = `${houseNumber} ${street}, ${
    isUS ? `${usState}, ` : ''
  }${city}, ${postCode}, ${selectedCountry?.displayName}`;
  const addWordBreakSpliterEmail = (text) => text.replace(/([.@+-_#])/g, '$1<wbr>');
  const addWordBreakSpliterAddress = (text) => text.replace(/([,])/g, '$1<wbr>');

  useEffect(() => {
    if (emailElmRef.current && email) {
      emailElmRef.current.innerHTML = addWordBreakSpliterEmail(email);
    }
  }, [emailElmRef, email]);

  useEffect(() => {
    if (addressElmRef.current && fullAddress) {
      addressElmRef.current.innerHTML = addWordBreakSpliterAddress(fullAddress);
    }
  }, [addressElmRef, fullAddress]);

  return (
    <div className="mt-3 d-flex flex-column w-100 h-lg-100 h-md-100 h-sm-100">
      <p className="text-f3 text-dark pe-5 text-bold letter-spacing-1 line-height-sm-1 line-height-2">
        {translate('personal_information_title_label')}
      </p>
      <p className="mt-3 text-f6 text-shadow letter-spacing-3">
        {translate('settings_personal_info_subtitle')}
      </p>
      <div className="bg-lighter rounded-extra py-4 px-4 mt-4">
        <p className="text-f5 text-dark text-bold letter-spacing-2">
          {translate('settings_personal_info_account_details_label')}
        </p>
        <div className="d-flex flex-lg-row flex-md-row flex-sm-row align-items-lg-center align-items-md-center align-items-sm-center flex-column mt-4">
          <div className="d-flex flex-row justify-content-start align-items-center col-lg-6 col-md-6 col-sm-6 col-12">
            <PersonalInfoUserSettingIcon />
            <div className="d-flex flex-column">
              <p className="text-f5 text-dark letter-spacing-2">{`${firstName} ${lastName}`}</p>
              <p className="text-f6 text-shadow letter-spacing-3">
                {translate('settings_personal_info_name_label')}
              </p>
            </div>
          </div>
          <div className="d-flex flex-row justify-content-start align-items-center ps-lg-1 ps-md-1 ps-sm-1 ps-0 col-lg-6 col-md-6 col-sm-6 col-12 mt-lg-0 mt-md-0 mt-sm-0 mt-4">
            <div
              className="rounded-max me-3 overflow-hidden"
              style={{
                height: isBrowser ? '2rem' : '2.2rem',
                width: isBrowser ? '2rem' : '2.2rem',
              }}>
              <img
                src={dynamicAssets(
                  `./assets/images/flags/1x1/${selectedCountry.iso3166alpha2}.svg`
                )}
                alt="County flag"
              />
            </div>
            <div className="d-flex flex-column">
              <p className="text-f5 text-dark letter-spacing-2">{selectedCountry.displayName}</p>
              <p className="text-f6 text-shadow letter-spacing-3">{translate('country_label')}</p>
            </div>
          </div>
        </div>
        <div className="d-flex flex-lg-row flex-md-row flex-sm-row align-items-lg-center align-items-md-center align-items-sm-center flex-column mt-4">
          <div className="d-flex flex-row justify-content-start align-items-center col-lg-6 col-md-6 col-sm-6 col-12">
            <PersonalInfoCalendarIcon />
            <div className="d-flex flex-column">
              <p className="text-f5 text-dark letter-spacing-2">{formatedDateOfBirth}</p>
              <p className="text-f6 text-shadow letter-spacing-3">{translate('date_label')}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-lighter rounded-extra py-4 px-4 mt-4">
        <p className="text-f5 text-dark text-bold letter-spacing-2">
          {translate('account_contact_information_title')}
        </p>
        <div className="d-flex flex-lg-row flex-md-row flex-sm-row align-items-lg-center align-items-md-center align-items-sm-center flex-column mt-4">
          <div className="d-flex flex-row justify-content-start align-items-center col-lg-6 col-md-6 col-sm-6 col-12">
            <PersonalInfoAtSymbolIcon />
            <div className="d-flex flex-column">
              <p
                ref={emailElmRef}
                style={{ wordBreak: 'break-word' }}
                className="text-f5 text-dark letter-spacing-2 pe-3">
                {email}
              </p>
              <p className="text-f6 text-shadow letter-spacing-3">
                {translate('settings_personal_info_email_address_label')}
              </p>
            </div>
          </div>
          <div className="d-flex flex-row justify-content-start align-items-center col-lg-6 col-md-6 col-sm-6 col-12 mt-lg-0 mt-md-0 mt-sm-0 mt-4">
            <PersonalInfoPhoneIcon />
            <div className="d-flex flex-column">
              <p className="text-f5 text-dark letter-spacing-2">{`${countryCode} ${normalizedPhoneNumber}`}</p>
              <p className="text-f6 text-shadow letter-spacing-3">
                {translate('settings_personal_info_phone_number_label')}
              </p>
            </div>
          </div>
        </div>
        <div className="d-flex flex-sm-row flex-column align-items-sm-center mt-4">
          <div className="d-flex flex-row justify-content-start align-items-center col-sm-6 col-12 mt-lg-0 mt-md-0 mt-sm-0">
            <PersonalInfoShopIcon />
            <div className="d-flex flex-column">
              <p
                ref={addressElmRef}
                className="text-f5 text-dark letter-spacing-2 pe-2"
                style={{ wordBreak: 'break-word' }}>
                {fullAddress}
              </p>
              <p className="text-f6 text-shadow letter-spacing-3">
                {translate('address_information_title_label')}
              </p>
            </div>
          </div>
        </div>
      </div>
      <p className="text-shadow mt-4 letter-spacing-2" style={{ fontSize: '14px' }}>
        <Trans
          i18nKey="settings_personal_info_contact_support_label"
          values={{
            support_email: ledgerSupportEmailAddress,
          }}
          components={[
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a
              key="contact-link-2"
              className="text-decoration-none"
              href={`mailto:${ledgerSupportEmailAddress}`}
              rel="noreferrer"
            />,
          ]}
        />
      </p>
    </div>
  );
};

export default PersonalInfo;
